export { default } from './ColorStyle'
